import { LogicalDeleteDTO } from '../basic/logicalDeleteDTO';
import { TenantDTO } from '../domain/tenant';

export class CatalogoDTO extends LogicalDeleteDTO {
    id: number;
    tenant: TenantDTO;
    descrizione: String;
    totaleCrediti: number;
}